<svg:g [style.opacity]="window.opacity">
  <rect id="window" class="window" [attr.x]="window.x" [attr.y]="window.y" [attr.width]="window.width"
    [attr.height]="window.height"></rect>

  <image class="remove" [attr.x]="window.x" [attr.y]="window.y - 5" [attr.width]="5" [attr.height]="5"
    xlink:href="assets/images/remove.png" (click)="onRemoveClick()">
  </image>
  <text class="measures-text" [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 4">A1 {{measures.A1 | number: '1.2-2' }}</text>
  <text class="measures-text" [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 10">A2 {{measures.A2 | number: '1.2-2' }}</text>
  <text class="measures-text" [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 16">&Delta;A {{measures.deltaA | number: '1.2-2' }}</text>
  <text class="measures-text" [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 22">&Delta;T {{measures.deltaT | number: '1.0-0' }}</text>
  <text class="measures-text" [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 28">HR {{measures.HR | number: '1.0-0' }}</text>
</svg:g>
